/* c8 ignore start */

import "./css/button.css";
import "./css/codemirror.css";
import "./css/index.css";

import { App } from "./App";
import BCError from "./displayComponents/errors/BroadcastChannel";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { reportWebVitals } from "./reportWebVitals";
import { strings } from "@quickpoint.me/shared";
import { initConversionTracking } from "./lib/conversionTracking";

// Capture ad click IDs (fbclid, rdt_cid) from URL early
initConversionTracking();

// ── Block IE completely ─────────────────────────────────────────────────────────
const isIE = /MSIE |Trident\//.test(window.navigator.userAgent);
if (isIE) {
	// Inform the user and stop script execution.
	document.body.innerHTML = `
    <div style="padding:1rem;font-family:sans-serif">
      QuickPoint does not support Internet&nbsp;Explorer.<br/>
      Please use a modern browser such as Chrome, Edge, Firefox or Safari.
    </div>`;
	// Prevent the rest of the bundle from running.
	throw new Error("Internet Explorer is not supported");
}
// ────────────────────────────────────────────────────────────────────────────────

console.info("Author Build Date: ", import.meta.env.VITE_BUILD_DATE);

const container = document.getElementById("author-root");
if (!container) {
	throw new Error('Root container element with id "author-root" not found.');
}
const root = createRoot(container);

const hasBroadcastChannel = () => {
	try {
		new BroadcastChannel(strings.broadcastChannel.general);
		return true;
	} catch {
		return false;
	}
};

if (hasBroadcastChannel()) {
	root.render(
		<StrictMode>
			<App />
		</StrictMode>,
	);
} else {
	root.render(<BCError />);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//console.log))
// or send to an analytics endpoint. Learn more: HTTPS://bit.ly/CRA-vitals
reportWebVitals();

/* c8 ignore stop */
